module.exports = __webpack_public_path__ + "media/images/flags/16/Bosnia-and-Herzegovina-6a0ff6b92264f71ea607162aed956f87.png";